<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-02-21 09:38:58
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-02-22 16:50:18
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/emergency/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <el-radio-group v-model="data" @change="changeData">
      <el-radio label="91">开启对外展示</el-radio>
      <el-radio label="92">关闭对外展示</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
import Api from "@/modules/projectA/api/approve/index";
export default {
  data() {
    return {
      data: "92",
    };
  },
  mounted() {
    this.getQueryYYJSwitch();
  },
  methods: {
    changeData() {
      this.getSaveYYJSwitch();
    },
    async getQueryYYJSwitch() {
      const result = await Api.queryYYJSwitch({});
      if (result.code === "200") {
        const data = result.data;
        if (data?.data) {
          this.data = data?.data;
        }
      }
    },
    // 设置
    async getSaveYYJSwitch() {
      console.log(this.data, "this.data");
      const result = await Api.saveYYJSwitch({ data: this.data });
      if (result.code === "200") {
        console.log(result);
        if(this.data === '91'){
          this.$message.success('开启成功');
        }else{
          this.$message.success('关闭成功');
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
